/**
 * Business logic per Orders autocomplete
 * Pura - senza dipendenze da Vue
 */

import { isArray } from 'lodash-es';
import ordersService from '../services/ordersService';
import type { JobOrderAutocompleteResult } from '../models/jobOrder';
import type { ExtendedAutocompleteOptions, ODataQueryBuilder } from './types';
import type { ODataContext } from '~/mixins/filterHandler/types';

export async function getOrdersAutocomplete(
	buildQuery: ODataQueryBuilder,
	options: ExtendedAutocompleteOptions = {},
): Promise<JobOrderAutocompleteResult[]> {
	const { searchString = '', id = null, notInIds = null, customerId = null } = options;

	const context: ODataContext = {
		select: 'id,code,name,isRequirementRequired',
		count: true,
		expand: {
			customer: {
				select: 'id,code,name',
			},
		},
		top: 20,
		orderBy: ['endDate desc', 'name'],
		filter: {
			and: [],
		},
	};

	if (searchString !== '') {
		context.filter!.and!.push({
			or: [
				{ 'tolower(code)': { contains: searchString } },
				{ 'tolower(name)': { contains: searchString } },
				{ 'tolower(customer/code)': { contains: searchString } },
				{ 'tolower(customer/name)': { contains: searchString } },
			],
		});
	} else if (id) {
		context.filter!.and!.push({
			id: { eq: id },
		});
	}

	if (notInIds && isArray(notInIds) && notInIds.length > 0) {
		context.filter!.and!.push({
			not: [
				{
					id: {
						in: notInIds,
					},
				},
			],
		});
	}

	if (customerId) {
		context.filter!.and!.push({
			customer: {
				id: customerId,
			},
		});
	}

	const result = await ordersService.getOrders(buildQuery(context));
	return result.value;
}
